var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumber6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.754 19.55c0-2.788.396-5.044 1.19-6.767.801-1.732 1.977-3.008 3.527-3.828 1.558-.82 3.477-1.23 5.756-1.23.81 0 1.759.077 2.843.232v4.225c-.911-.174-1.9-.26-2.966-.26-1.805 0-3.15.396-4.034 1.19-.884.792-1.367 2.087-1.449 3.882h.164c.82-1.55 2.137-2.324 3.951-2.324 1.778 0 3.154.574 4.13 1.723.984 1.139 1.476 2.73 1.476 4.771 0 2.197-.62 3.933-1.86 5.209-1.24 1.267-2.97 1.9-5.195 1.9-2.36 0-4.206-.765-5.537-2.296-1.33-1.532-1.996-3.674-1.996-6.426zm7.41 4.444c.574 0 1.04-.214 1.395-.642.364-.438.546-1.13.546-2.079 0-1.622-.628-2.433-1.886-2.433-.62 0-1.126.21-1.518.629-.383.419-.574.93-.574 1.531 0 .875.187 1.595.56 2.16.374.556.866.834 1.477.834z",
    fill: "#fff",
    fillOpacity: 0.2
  })));
}

export default SvgNumber6;